export const validateEmail = (email: string): boolean => {
  if (!email) return true; // Empty email is valid (not required)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
